module.exports = __webpack_public_path__ + "img/dm-logo-white.aad3ca68.png";